import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=3cab174f&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=3cab174f&scoped=true&lang=scss"
import style1 from "./detail.vue?vue&type=style&index=1&id=3cab174f&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cab174f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cab174f')) {
      api.createRecord('3cab174f', component.options)
    } else {
      api.reload('3cab174f', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=3cab174f&scoped=true", function () {
      api.rerender('3cab174f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportManage/games/detail.vue"
export default component.exports